<h2 mat-dialog-title>
  <div class="dialog-title">
    <span>Customer Search</span>
    <span class="spacer"></span>
    <span class="count" *ngIf="count !== null">Matches: {{ count | number }}</span>
  </div>
</h2>

<mat-dialog-content class="dialog-content">
  <mat-tab-group>
    <mat-tab label="Search">

      <div class="column">
        <div class="row builder">
          <!-- Basic Filters -->
          <div class="column" style="flex: 1;">
            <div class="row">
              <mat-form-field appearance="fill">
                <mat-label>Keyword</mat-label>
                <input matInput [formControl]="keywordCtrl" />
              </mat-form-field>
            </div>
      
            <div class="row">
              <mat-form-field appearance="fill">
                <mat-label>Registration</mat-label>
                <mat-select [formControl]="registrationCtrl">
                  <mat-option value="both">Registered & Anonymous</mat-option>
                  <mat-option value="registered">Registered</mat-option>
                  <mat-option value="anonymous">Anonymous</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
      
            <div class="row">
              <mat-form-field appearance="fill">
                <mat-label>Devices</mat-label>
                <mat-select [formControl]="devicesCtrl">
                  <mat-option value="latest_per_user">Latest per user</mat-option>
                  <mat-option value="all_per_user">All per user</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
      
            <div class="row">
              <mat-form-field appearance="fill">
                <mat-label>Include</mat-label>
                <mat-select [formControl]="includeCtrl" multiple>
                  <mat-option value="appUser">App User</mat-option>
                  <mat-option value="device">Device</mat-option>
                  <mat-option value="activeGeofences">Active Geofences</mat-option>
                  <mat-option value="activeBeaconRegions">Active Beacon Regions</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
      
            <div class="row">
              <mat-slide-toggle color="lightGreen" [formControl]="includeNullFacilitiesCtrl">
                Include null facilities
              </mat-slide-toggle>
            </div>
          </div>
  
          <!-- Query Builder-->
          <div class="column" style="flex: 2;">
            <lhpe-query-builder class="builder"
              [columns]="columnsForBuilder"
              [initialWhere]="data?.initialQuery?.where || null"
              (whereChange)="onWhereChange($event)"
            ></lhpe-query-builder>
          </div>
        </div>
      </div>
      
    </mat-tab>
    <!--
    <mat-tab label="AI Search">
      <div class="row">
        <mat-form-field appearance="fill" style="flex:1">
          <mat-label>Ask AI</mat-label>
          <input matInput placeholder="e.g. Customers who visited Building A twice last week" />
          <mat-hint>Natural language search. We’ll convert to filters.</mat-hint>
        </mat-form-field>
      </div>
    </mat-tab>
    -->
    <mat-tab label="Saved Searches">
      <div class="saved-list" role="list">
        <div class="saved-item" role="listitem" *ngFor="let s of savedSearches">
          <div class="saved-name">{{ s.name }}</div>
          <div class="actions">
            <button mat-icon-button color="lightGreen" matTooltip="Run" aria-label="Run saved search" (click)="onSavedSelected(s.id)">
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Edit" aria-label="Edit saved search" (click)="editSaved(s)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" matTooltip="Delete" aria-label="Delete saved search" (click)="deleteSaved(s)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="row query-row" *ngIf="queryText && queryText.length">
    <div class="query-text">{{ queryText }}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-stroked-button (click)="save()">Save</button>
  <button mat-stroked-button color="lightGreen" (click)="apply()">Apply</button>
  
</mat-dialog-actions>


